import {
  REMOVE_ROLE,
  LOAD_ROLES,
  LOAD_ROLE,
  ADD_ROLE,
  UPDATE_ROLE,
} from '../../actions/roles';

export default function roles(state = {}, action) {
  switch (action.type) {
    case REMOVE_ROLE:
      for (let i = 0; i < state.list.length; i++) {
        if (state.list[i].id == action.payload.id) {
          state.list.splice(i, 1);
        }
      }
      return Object.assign({}, state, action.payload);
    case LOAD_ROLES:
      return Object.assign({}, state, action.payload);
    case LOAD_ROLE:
      return Object.assign({}, state, action.payload);
    case ADD_ROLE:
      return Object.assign({}, state, action.payload);
    case UPDATE_ROLE:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/roles/index.js